import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil-fill",
  "use": "pencil-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"pencil-fill\"><path d=\"M11.3 2.018l.507-.508a2.141 2.141 0 013.025 0 2.134 2.134 0 010 3.021l-.508.508L11.3 2.018zM3.297 9.984l7.286-7.276 3.03 3.026-7.286 7.277-3.03-3.027zm-1.338 4.722a.3.3 0 01-.354-.354L2.287 11l3.029 3.025-3.357.68z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol